import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {consultantDictionary, ControlConsultantComponent} from '../../../controls/agyle/clinitian';
import config from '../../../app/config';
import {useDispatch} from 'react-redux';
import {useEffect, useState} from 'react';
import * as _ from 'lodash';
import AgyleToggleButtons from '../../../components/ui/buttons/agyleToggleButtons';
import * as React from 'react';
import {FormControl, FormLabel, MenuItem, Select, Grid} from '@mui/material';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: '#448FFF',
    },
    baToggle_classNameRoot: {
        color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
        backgroundColor: theme.palette.mode === "dark" ? "#313233" : "#bfc2c7",
        // padding: 3
        display: "inline-block"
    },
    baToggle_classNameRootSecond: {
        color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#bfc2c7",
        // padding: 3
    },
    baToggle_classNameLabel: {
        color: theme.palette.mode === "dark" ? "#ACAFB3" : "#f3f3f4",
        "&.Mui-disabled": {
            border: "none",
        }
    },
    baToggle_classNameSelected: {
        color: theme.palette.mode === "dark" ? "black !important" : "#ffffff !important",
        fontWeight: theme.palette.mode === "dark" ? 400 : 600,
        backgroundColor: theme.palette.mode === "dark" ? "#ffffff !important" : "#626466 !important"
    },
    componentPicker: {
        padding: "8px 0px",
        border: "1px solid",
        borderColor: theme.palette.mode === "dark" ? "#585858" : "#bfc2c7",
        borderRadius: "5px",
        '&:hover': {
            borderColor: theme.palette.mode === "dark" ? "#afafaf" : "#e7e9ec",
            borderWidth: "1.5px"
        }
    },
    resultWindow: {
        maxWidth: "100%",
        maxHeight: "300px",
        wordWrap: "break-word",
        overflowY: 'auto',
        overflowX: 'hidden'
    }
}));

function ConsultantPickerTest(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const [consultantComponentEnabled, setConsultantComponentEnabled] = useState(config.consultantComponentEnabled ? 1 : 0)
    const [allowedCons, setAllowedCons] = useState("")
    const [selectedCons, setSelectedCons] = useState([])

    const setClinicians = (v) => {
        setSelectedCons(v);
    }

    const setConfig = (v) => {
        if(v != null){
            setConsultantComponentEnabled(v)
            window.envConfig.consultantComponentEnabled = v == 0 ? false : true;
        }
    }

    return (
        <>
            <Grid container>
                <Grid item xs={7} sx={{px: 1, marginTop: '20px'}}>
                    {/*enable new way [{config?.consultantComponentEnabled}]*/}

                    <AgyleToggleButtons
                        classNameRoot={classes.baToggle_classNameRoot}
                        classNameLabel={classes.baToggle_classNameLabel}
                        classNameSelected={classes.baToggle_classNameSelected}
                        onChange={setConfig}
                        value={consultantComponentEnabled}
                        size="small"
                        disabled={false}
                        options={[
                            {value: 0, label: 'OLD'},
                            {value: 1, label: 'NEW'},
                        ]}
                        minWidth={100}
                    />
                </Grid>
                <Grid item xs={7} sx={{px: 1, marginTop: '20px'}}>
                    <FormControl sx={{width: "70%"}}>
                        <FormLabel id="allowed_config-role-label">{t("Test Access")}</FormLabel>
                        <Select
                            labelId="allowed_config-role-label"
                            id="allowed_config-role"
                            disabled={false}
                            value={allowedCons}
                            onChange={(selected)=> {setAllowedCons(selected.target.value)}}
                        >
                            <MenuItem value="" key="empty-option-person-completing-role">
                                <em>None</em>
                            </MenuItem>
                            {consultantDictionary && Object.keys(consultantDictionary).map((r, index)=>{
                                return (
                                    <MenuItem value={consultantDictionary[r]} key={index + "_" + consultantDictionary[r]}>{consultantDictionary[r]}</MenuItem>
                                )
                            })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={7} sx={{px: 1, marginTop: '20px'}} >
                    <FormControl sx={{width: "70%"}}>
                        <FormLabel id="test-clinician-component-label">{t("Test Clinician")}</FormLabel>
                        <div className={classes.componentPicker}>
                            <ControlConsultantComponent
                                labelId="test-clinician-component-label"
                                // label={t("Clinician search")}
                                showAll
                                agyleRefresh
                                allowedConsultants={allowedCons}
                                size="small"
                                onChange={setClinicians}
                                value={selectedCons}
                                multiple
                            />
                        </div>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sx={{px: 1, marginTop: '20px'}} className={classes.resultWindow}>
                    {JSON.stringify(selectedCons)}
                </Grid>
            </Grid>
        </>
    )

}

export {
    ConsultantPickerTest
}